import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import moment from "moment";
import { LocaleType } from "@/model";
import localeAtom from "@/atom/locale";


export const useLocale = () => {
    const [locale, setLocaleAtom] = useAtom(localeAtom);

    const setLocale = useCallback((locale: LocaleType) => {
        moment.locale(locale);
        setLocaleAtom(locale);
    }, [setLocaleAtom]);

    return useMemo(() => {
        return { locale, setLocale };
    }, [locale, setLocale]);
};
